export const ACTION_TYPES = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  PRICE_MODIFICATION: 'MODIFICACIÓN DE PRECIO',
  PRICE_SELECTION: 'SELECCIÓN DE PRECIO',
  RE_EXECUTION: 'REEJECUCIÓN',
  SEND_TO_MIBGAS: 'ENVÍO A MIBGAS',
  RE_SEND_TO_MIBGAS: 'REENVÍO A MIBGAS',
  PARAMETER_UPDATE: 'ACTUALIZACIÓN DE PARÁMETROS',
  CONFIG_CHANGE: 'CAMBIO DE CONFIGURACIÓN',
  DATA_QUERY: 'CONSULTA DE DATOS',
  DELETE_RECORD: 'ELIMINACIÓN DE REGISTRO',
  CREATE_RECORD: 'CREACIÓN DE REGISTRO',
  UPDATE_RECORD: 'ACTUALIZACIÓN DE REGISTRO',
  FAST_MARKET_ACTION: 'ACCIÓN DE MERCADO RÁPIDO',
  FAST_MARKET_SEND: 'ENVÍO DE MERCADO RÁPIDO',
  THRESHOLD_UPDATE: 'ACTUALIZACIÓN DE UMBRAL',
  MARGIN_UPDATE: 'ACTUALIZACIÓN DE MARGEN'
};
